import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Task } from '@app/_models';
import { AccountService } from '@app/_services';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(
    private http: HttpClient,
    private accountService: AccountService
  ) { }

  getAll(filter?: object) {
    let fstr = filter  ? stringi(filter) : '&';
    return this.http.get<Task[]>(`/api/tasks?${fstr.substring(1)}`).pipe(first());
  }

  getById(id: string) {
    return this.http.get<Task>(`/api/tasks/${id}`).pipe(first());
  }

  update(id: string, params: any) {
    return this.http.put<Task>(`/api/tasks/${id}`, params).pipe(first());
  }

  add(params: any) {
    return this.http.post<Task>(`/api/tasks`, params).pipe(first());
  }

  delete(id: string) {
    return this.http.delete(`/api/tasks/${id}`).pipe(first());
  }
}

function stringi(ob: any, path = ''): string {
  if (typeof ob === 'object') {
      if (path.length)
          return Object.keys(ob).map(k => stringi(ob[k], `${path}[${k}]`)).join('');
      else
          return Object.keys(ob).map(k => stringi(ob[k], k)).join('');
  }
  else
      return '&' + path + '=' + ob;
}
